import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Cuenta_area/cuenta_area';
import CuentaAreaGrid from './CuentaAreaGrid.js';

const mstp = state => {
    return {...state.cuenta_area}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(CuentaAreaGrid)
